<template>
    <div id="save-all-as-candidates-unprocessed-list-modal" class="hidden modal-new">
        <btnClose></btnClose>
        <span class="title">Saving as Candidate skipped processing of following files</span>
        <p class="description text-left">The following files are missing ACES Input Transform so they were not processed.
            Please apply the appropriate ACES Input Transform and re-run Save as Candidate.</p>

        <div class="list-con">
            <template v-for="(file, index) in list">
                <div v-if="index <= 9" class="item-con" :key="file.id">
                    <span v-if="index < 9">{{ stripTimestamp(file.name) }}</span>
                    <span v-if="index == 9">+ {{ list.length - 9 }} more</span>
                </div>
            </template>
        </div>

        <div class="buttons-continer">
            <button type="button" class="modal-btn --primary" @click="onConfirm">
                <span>Close</span>
            </button>
        </div>
    </div>
</template>

<script>
import btnClose from '@/components/app/buttons/modal/Close'
import FilenameMixin from '@/mixins/Filename';
import { mapState } from 'vuex'

export default {
    mixins: [FilenameMixin],

    components: {
        btnClose,
    },

    computed: {
        ...mapState('Projects', {
            list: 'saveAllAsCandidatesUnprocessedList'
        }),
    },

    methods: {
        onConfirm() {
            this.$store.commit('Projects/RESET_SAVE_ALL_AS_CANDIDATES_UNPROCESSED_LIST');
            window.UI.hideModal()
        },
    },
}
</script>

<style lang="scss">
#save-all-as-candidates-unprocessed-list-modal {
    width: 35vw;

    .list-con {
        margin-bottom: 30px;
        height: 320px;
    }

    .item-con span {
        line-height: 1.2;
    }
}
</style>
